import React from 'react';

function PayoutWebMoneyId({ wmid }) {
	return (
		<img src={`https://bl.wmtransfer.com/img/bl/${wmid}?w=35&h=18&bg=0XDBE2E9`} />
	);
}

export default PayoutWebMoneyId;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/components/payout-credentials/components/payout-web-money-id/index.js